<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-ticket text-primary mr-2"></i>
                    Gestión de Convenios
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Listado
                    <export-actions :rows="getAgreementsFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="AgreementsTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="agreements"
                    :options="options"
                    :theme="theme" @filter="onFilter">

                    <template slot="uuid" slot-scope="props">
                        <router-link :to="{ path: '/admin/agreements/edit/'+props.row.uuid }">
                            <i class="fa fa-pencil"></i>
                        </router-link>
                    </template>

                    <template slot="startDate" slot-scope="props">
                        {{ props.row.startDate | dateFormat('DD/MM/YYYY') }}
                    </template>

                    <template slot="endDate" slot-scope="props">
                        {{ props.row.endDate | dateFormat('DD/MM/YYYY') }}
                    </template>

                    <template slot="type" slot-scope="props">
                        {{ getAgreementType(props.row.type) }}
                    </template>

                </v-client-table>

            </b-card>
        </b-row>

    </div>
</template>

<script>
    import Vue from 'vue';
    import VueNotifications from 'vue-notifications';
    import form from '@/helpers/form';
    import {ClientTable, Event} from 'vue-tables-2';
    import ExportActions from '@/components/ExportActions';
    import {mapState} from 'vuex';
    import {getAgreementTypeByKey} from '@/helpers/agreement-helper';

    Vue.use(ClientTable);

    export default {
        name: 'listAgreements',
        components: {
            ExportActions
        },
        data: function () {
            return {
                topmenu: [
                    {name: 'Inicio', path: '/admin/dashboard', brand: 'fa fa-home'},
                    {
                        name: 'Nuevo Convenio',
                        path: '/admin/agreements/add',
                        brand: 'fa fa-ticket',
                        permissions: ['AGREEMENT_NEW']
                    },
                ],
                items_url: 'agreements',
                columns: ['uuid', 'entity', 'name', 'startDate', 'endDate', 'type'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        entity: 'Entidad',
                        name: 'Nombre',
                        startDate: 'Inicio',
                        endDate: 'Fin',
                        type: 'Tipo'
                    },
                    columnsClasses: {uuid: "fit"},
                    sortable: ['entity', 'name', 'startDate', 'endDate', 'type'],
                    filterable: ['entity', 'name'],
                    sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
                items: [],
            }
        },
        mounted() {
            this.options.texts = form.tableLabels();
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.loadAgreements();
        },
        computed: {
            ...mapState([
                'agreements'
            ]),
            agreements: {
              get: function () {
                return this.$store.state.agreements.list;
              },
              set: function (val) {
                this.$store.commit('SET_AGREEMENTS_LIST', val);
              }
            }
        },
        methods: {
            loadAgreements() {
                this.$_loadingMixin_showLoading();
                this.$store.dispatch('loadAgreements').finally(() => {
                  let searchValue = this.$store.getters.getTextFilter;
                  if (searchValue === null || searchValue === '') {
                    //console.log(this.headquarters)
                  }  else {
                    document.querySelector('.VueTables__search__input').value  = this.$store.getters.getTextFilter;
                    let filteredLists = []
                    this.agreements.map(function (e) {
                      if (e.entity.includes(searchValue) || e.name.includes(searchValue)) {
                        filteredLists.push(e)
                      }
                    });
                    this.agreements = filteredLists;
                  }
                    this.$_loadingMixin_hideLoading();
                });
            },
            getAgreementsFilteredData() {
                if (!!this.agreements.list) {
                    return this.agreements.list.map(agreement => ({
                        'Entidad': agreement.entity,
                        'Nombre': agreement.name,
                        'Inicio': agreement.startDate.toLocaleDateString(),
                        'Fin': agreement.endDate.toLocaleDateString(),
                        'Tipo': this.getAgreementType(agreement.type)
                    }));
                } else {
                    return [];
                }
            },
            getAgreementType(type) {
                return getAgreementTypeByKey(type);
            },
            onFilter () {
              let _self = this;
              if (document.querySelector('.VueTables__search__input').value === '') {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
                _self.loadAgreements();
              } else {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
              }
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Operación Completada',
                message: 'Registro almacenado con éxito'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Operación denegada',
                message: 'Algo salió mal'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Operación Rechazada',
                message: 'Por favor, revise los campos'
            }
        },
    }
</script>
